const steps = [
  {
    step: '01',
    icon: 'ri-edit-line',
    title: 'Tell Us What You Need',
    description: 'Customers or businesses complete a simple energy enquiry so we understand your requirements, property details and energy goals.',
    color: 'bg-rose-50',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-500',
    accentColor: '#f43f5e',
  },
  {
    step: '02',
    icon: 'ri-scales-3-line',
    title: 'Compare Suitable Options',
    description: 'AK Energy helps compare categories, partners and potential solutions matched to your specific needs and budget.',
    color: 'bg-primary-50',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-500',
    accentColor: '#2FA84F',
  },
  {
    step: '03',
    icon: 'ri-user-heart-line',
    title: 'Connect With Trusted Providers',
    description: 'Users are matched with relevant installers, manufacturers or finance partners who have been verified and reviewed.',
    color: 'bg-secondary-50',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-500',
    accentColor: '#37A9E0',
  },
  {
    step: '04',
    icon: 'ri-dashboard-line',
    title: 'Manage The Journey',
    description: 'Future platform tools support documents, dashboards, energy monitoring and optimisation for ongoing energy management.',
    color: 'bg-accent-50',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-500',
    accentColor: '#F4D13D',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start mb-14 md:mb-20">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-secondary-600 mb-4">The Process</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight" style={{ color: '#111827' }}>
              How AK Energy
              <span className="relative ml-3 italic font-serif" style={{ color: '#37A9E0' }}>
                Works
              </span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              From enquiry to ongoing management, our platform guides you through every stage of the renewable energy journey.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <div
              key={s.step}
              className={`group relative ${s.color} rounded-2xl p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 cursor-default`}
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="flex items-center justify-between mb-5">
                <div className={`w-12 h-12 rounded-xl ${s.iconBg} flex items-center justify-center`}>
                  <i className={`${s.icon} ${s.iconColor} text-xl`}></i>
                </div>
                <span className="text-3xl font-extrabold opacity-30" style={{ color: s.accentColor }}>
                  {s.step}
                </span>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{s.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}